import { SvgProps } from './types'

export const HouseBlueprintIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_3733_1461)">
        <path
          d="M24.1245 19.9348L14.7561 12.2139L5.3877 19.9348"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.38599 18.3818V27.4507H22.1264V18.3818"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3377 20.9751H12.1707V27.4506H17.3377V20.9751Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.3877 34.8486V31.9912"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.1245 33.4219H5.3877"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.1245 34.8486V31.9912"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.2339 39.4798H0.52417V7.02734H28.9881"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.4797 34.2337V5.76586C39.4797 2.86902 37.1307 0.52002 34.2339 0.52002C31.337 0.52002 28.988 2.86902 28.988 5.76586V34.2337"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.2339 39.48C37.1311 39.48 39.4797 37.1313 39.4797 34.2341C39.4797 31.3369 37.1311 28.9883 34.2339 28.9883C31.3367 28.9883 28.988 31.3369 28.988 34.2341C28.988 37.1313 31.3367 39.48 34.2339 39.48Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.2339 36.1811C35.3091 36.1811 36.1808 35.3094 36.1808 34.2341C36.1808 33.1588 35.3091 32.2871 34.2339 32.2871C33.1586 32.2871 32.2869 33.1588 32.2869 34.2341C32.2869 35.3094 33.1586 36.1811 34.2339 36.1811Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
